var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569ZM9.48718 5.58305C9.34331 5.70322 9.2462 5.87008 9.2128 6.05453L9.2 6.19853V10.1985L9.2128 10.3425C9.2462 10.527 9.34331 10.6939 9.48718 10.814C9.63105 10.9342 9.81255 11 10 11C10.1875 11 10.3689 10.9342 10.5128 10.814C10.6567 10.6939 10.7538 10.527 10.7872 10.3425L10.8 10.1985V6.19853L10.7872 6.05453C10.7538 5.87008 10.6567 5.70322 10.5128 5.58305C10.3689 5.46289 10.1875 5.39707 10 5.39707C9.81255 5.39707 9.63105 5.46289 9.48718 5.58305ZM9.48718 12.3845C9.34331 12.5047 9.2462 12.6715 9.2128 12.856L9.2 13L9.2128 13.144C9.2462 13.3285 9.34331 13.4953 9.48718 13.6155C9.63105 13.7356 9.81255 13.8015 10 13.8015C10.1875 13.8015 10.3689 13.7356 10.5128 13.6155C10.6567 13.4953 10.7538 13.3285 10.7872 13.144L10.8 13L10.7872 12.856C10.7538 12.6715 10.6567 12.5047 10.5128 12.3845C10.3689 12.2644 10.1875 12.1985 10 12.1985C9.81255 12.1985 9.63105 12.2644 9.48718 12.3845Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "c5d257c41880cc5c8aeb43a11ceb3838.svg";
export { ForwardRef as ReactComponent };